<template>
  <section class="video">
    <div class="video_wrap" @click="onClickThumbnail" >
      <div class="video_thumbnail" v-if="isShowThumbnail">
        <ul>
          <li><img class="video_logo" src="../../assets/image/logo_1.png"></li>
          <li><span class="video_title">Play the video</span></li>
        </ul>
      </div>
      <video ref="video"
             class="contec_video" width="100%" height="auto" src="../../assets/image/contec_video.mp4" controls></video>

    <!--<div class="video-container">
      <iframe width="560" height="315" src="https://www.youtube.com/embed/Fs8YckLuq1c" title="YouTube video player" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
    </div>-->

    </div>
  </section>
</template>

<script>
export default {
  name: "Video",
  data() {
    return {
      isShowThumbnail: true,
    }
  },
  methods: {
    onClickThumbnail() {
      this.isShowThumbnail = false
      this.$refs['video'].play()
    }
  }
}
</script>

<style scoped>

</style>